import React, { useState, useMemo, useEffect, Fragment } from "react";
import { Container } from "reactstrap";
import { Navbar, NavbarBrand } from "reactstrap";
// import Logo from "../Assets/Images/logo.svg";
import Logo from "../../Assets/Images/logo_aisight.svg";
import { Row, Col, Radio, Table, Select, Spin, DatePicker, Input, Checkbox, Button, Tooltip } from "antd";
import { BulbOutlined, CloudOutlined, EyeOutlined, StarOutlined } from "@ant-design/icons";
import "antd/dist/antd.css";
import { DataService } from "../../Services";
import { GoogleMap } from "../Common";
import HandleMarkerClick from "../Home/Markers/HandleMarkerClick";
import moment from "moment";
import { isEmpty, orderBy } from "lodash";
// import ViewShopDetails from "./VIewShopDetails";
import { DownloadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import { format } from "date-fns";

const screenRatio = 1.7778;
const heightFactor1 = 0.55; //0.59;
const mapHeight = Math.floor((window.innerWidth / screenRatio) * heightFactor1);
const { Option } = Select;

const areaData = [
	{ _id: "678f8f6067236dcba9719714", name: "Zurich", sub_areas: ["678f8f6067236dcba9719716"], parent_area: null },
	{ _id: "678f8f6067236dcba9719716", name: "District 1", sub_areas: [], parent_area: "678f8f6067236dcba9719714" }
];

const getPolygon = locations => {
	console.log({ length: locations.length, locations });
	// locations = locations.filter(obj => obj?.data?.census_list.length > 0 && obj.data?.store_list.length > 0);
	return {
		polygons: locations.map((obj, ind) => {
			const {
				data: { store_list, census_list, SEC, population, smoking_area_id }
			} = obj;
			return {
				id: ind,
				_id: ind,

				coordinates: obj?.boundary?.polygon,
				style: {
					fillColor: "#FFFFFF11",
					strokeColor: "#000000",
					zindex: 10
				},
				data: {
					store_list,
					census_list,
					SEC,
					population,
					smoking_area_id
				},
				filterData: {
					value: obj?.data?.population || 0
				},
				polygonClick: true
			};
		})
	};
};

const filterShops = (shops, filter, timeOfDay, channelType, aisightChannel, selectedDate, numberOfShopsToShow) => {
	let filteredShops = Object.values(shops);
	if (channelType.length) {
		filteredShops = filteredShops.filter(shop => channelType.includes(shop.data?.channel));
	}
	if (aisightChannel.length) {
		filteredShops = filteredShops.filter(shop => aisightChannel.includes(shop.data?.aisight_channel));
	}

	if (!filteredShops || filteredShops.length === 0) return [];

	const scoreKey = `${timeOfDay.toLowerCase()}_score`; // "morning_score", etc.

	let enriched = filteredShops
		.map(shop => {
			const selectedDayResult = shop.data?.date_score?.[selectedDate]?.[scoreKey] ?? "LOW";
			const selectedDateResult = shop.data?.date_score?.[selectedDate] || {};
			const sales = Number(shop.data?.sales ?? 0);
			const score = shop.data?.score || 0;

			return {
				...shop,
				selectedDayResult,
				sales,
				score,
				selectedDateResult,
				dateRecords: shop.data?.date_score,
				selectedDate
			};
		})
		.filter(shop => shop.score > 0);

	if (filter === "Footfall") {
		enriched = orderBy(enriched, ["sales"], ["desc"]);
		enriched = enriched.filter(shop => shop.selectedDayResult === "HIGH");

		enriched = orderBy(enriched, ["score"], ["desc"]);
		enriched = enriched.slice(0, numberOfShopsToShow);
	} else {
		enriched = enriched.filter(shop => shop.data.growth_potential === "Yes");

		enriched = enriched.filter(shop => shop.selectedDayResult === "HIGH");
		console.log("enriched", enriched);
		enriched = orderBy(enriched, ["score"], ["desc"]);
		enriched = enriched.slice(0, numberOfShopsToShow);
	}

	// 3️⃣ Format and return
	const newList = enriched.map(({ ...shop }) => ({
		...shop
	}));

	// slice to limit number of shops shown
	filteredShops = enriched.reduce((acc, shop) => {
		acc[shop.id] = shop;
		return acc;
	}, {});

	return { newList, filteredShops };
};

const assignScore = (
	shops,
	filter,
	timeOfDay,
	channelType,
	aisightChannel,
	selectedDate,
	numberOfShopsToShow,
	geographicDiversity,
	allPolygons,
	shopsEachPolygon
) => {
	if (geographicDiversity || filter === "Growth Potential") {
		const equalNumber = shopsEachPolygon;
		if (allPolygons) {
			const diversityData = {
				newList: [],
				filteredShops: {}
			};
			allPolygons = Object.values(allPolygons).forEach(({ data: { store_list } }) => {
				const shopsInPolygon = Object.values(shops).filter(({ id }) => {
					return store_list.includes(id);
				});
				const filteredShops = filterShops(
					shopsInPolygon,
					filter,
					timeOfDay,
					channelType,
					aisightChannel,
					selectedDate,
					equalNumber
				);

				diversityData.newList.push(...(filteredShops.newList || []));
				Object.assign(diversityData.filteredShops, filteredShops.filteredShops);
			});
			// sort the newList by score
			diversityData.newList = orderBy(diversityData.newList, ["data.score"], ["desc"]);
			console.log({ diversityData });
			return diversityData;
		}
	}
	return filterShops(shops, filter, timeOfDay, channelType, aisightChannel, selectedDate, numberOfShopsToShow);
};

// const COLORS = ["#52c41a", "#1890ff", "#faad14", "#722ed1"];

const PromotorSchedule = () => {
	const cities = useMemo(() => areaData.filter(a => a.parent_area === null), []);
	const [selectedCity, setSelectedCity] = useState(cities[0]._id);
	const districts = useMemo(() => areaData.filter(a => a.parent_area === selectedCity), [selectedCity]);
	const [selectedDistrict, setSelectedDistrict] = useState(districts[0]?._id || "");

	const [downloadScope, setDownloadScope] = useState("City");
	const [shopCache, setShopCache] = useState({});
	const [shopList, setShopList] = useState([]);
	const [loadingShops, setLoadingShops] = useState(false);

	const [timeOfDay, setTimeOfDay] = useState("Morning");
	const [filter, setFilter] = useState("Footfall");

	const [allMarkers, setAllMarkers] = useState({});

	const [mapMarkers, setMapMarkers] = useState({});
	const [mapCenter, setMapCenter] = useState(null);

	const [markerCardVisible, setMarkerCardVisible] = useState(false);
	const [selectedMarker, setSelectedMarker] = useState(null);
	const [allChannels, setAllChannels] = useState([]);
	const [allAisightChannels, setAllAisightChannels] = useState([]);
	const [selectedChannel, setSelectedChannel] = useState([]);
	const [selectedAisightChannel, setSelectedAisightChannel] = useState([]);
	const [selectedDate, setSelectedDate] = useState(null);
	const [availableDates, setAvailableDates] = useState([]);
	const [numberOfShopsToShow, setNumberOfShopsToShow] = useState(10);
	const [shopsEachPolygon, setShopsEachPolygons] = useState(2);

	const [polygonsForMap, setPolygonsForMap] = useState({});
	// eslint-disable-next-line
	const [allPolygons, setAllPolygons] = useState({});

	const [geographicDiversity, setGeographicDiversity] = useState(false);

	const handleExport = () => {
		// convert your shopList (array of objects) into a worksheet
		const shopsForExport = shopList.map(shop => ({
			census_id: shop.census_id,

			name: shop.name,
			score: shop.data.score,
			channel: shop.data.channel,
			aisight_channel: shop.data.aisight_channel,
			lat: shop.position.lat,
			lng: shop.position.lng,
			"Morning Footfall": shop.data.date_score[selectedDate]?.morning_score || "N/A",
			"Afternoon Footfall": shop.data.date_score[selectedDate]?.afternoon_score || "N/A",
			"Evening Footfall": shop.data.date_score[selectedDate]?.evening_score || "N/A",
			"geographic zone": shop.data.route || "N/A"
		}));

		const worksheet = XLSX.utils.json_to_sheet(shopsForExport);
		// create a new workbook and append the worksheet
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Shops");
		// write the file and trigger the download
		XLSX.writeFile(workbook, "shop_list.xlsx");
	};

	// const data = progressMap[selectedMonth]?.[filter]?.[timeOfDay] || { week1: 0, week2: 0, week3: 0, week4: 0 };
	// const total = Object.values(data).reduce((a, b) => a + b, 0) || 1;

	const shopColumns = [
		{ title: "Shop Name", dataIndex: "name", key: "name" },
		{ title: "Score", dataIndex: "score", key: "score", align: "right", render: v => Number(v).toFixed(2) },
		{ title: "Channel", dataIndex: ["data", "channel"], key: "channel" },
		{ title: "Aisight Channel", dataIndex: ["data", "aisight_channel"], key: "aisight_channel" },
		{
			title: "",
			dataIndex: "census_id",
			key: "census_id",
			render: (_, record) => {
				return (
					<Button
						className="view-shop-details-button px-2 d-flex align-items-center justify-content-center"
						icon={<EyeOutlined />}
						// loading={loading}
						type="primary"
						size="middle"
						onClick={() => {
							const marker = allMarkers[record.id];
							setMarkerCardVisible(true);
							setSelectedMarker(marker);
						}}
					>
						Details
					</Button>
				);
				// return <ViewShopDetails record={record} />;
			}
		}
	];

	useEffect(() => {
		handleDownload();
	}, [selectedCity, selectedDistrict, downloadScope]);
	const handleDownload = async () => {
		const id = downloadScope === "City" ? selectedCity : selectedDistrict;
		let polygonData = await DataService.fetchDataFromS3(
			"BAT_SWITZERLAND",
			"678f8f6067236dcba9719714",
			"promotor_polygons"
		);

		if (polygonData.locations) {
			const data = getPolygon(polygonData.locations);

			setPolygonsForMap(data.polygons);
			setAllPolygons(data.polygons);
		}
		if (shopCache[id]) {
			setShopList(shopCache[id]);
			return;
		}
		setLoadingShops(true);
		try {
			const res = await DataService.fetchClientShopsOfPolygon({
				params: {
					key: id,
					selectedType: downloadScope.toUpperCase(),
					exclude: [],
					config: [
						"_id",
						"name",
						"location.coordinates",
						"outlet_data.census_id",
						"outlet_data.channel",
						"outlet_data.aisight_channel",
						"outlet_data.sales",
						"outlet_data.afternoon_score",
						"outlet_data.morning_score",
						"outlet_data.evening_score",
						"outlet_data.dates_score",
						"outlet_data.score",
						"outlet_data.growth_potential",
						"outlet_data.code",
						"outlet_data.route"
					]
				}
			});
			const markers = res.data.shopMarkers;

			let allChannels = [];
			let allAisightChannels = [];
			const mk = {};
			let temDate = moment().format("DD-MM-YYYY");
			markers.forEach(
				([
					sid,
					name,
					coord,
					census_id,
					channel,

					aisight_channel,
					sales,
					afternoon_score,

					morning_score,
					evening_score,
					dates_score,
					score,
					growth_potential,
					code,
					route
				]) => {
					console.log({
						sid,
						name,
						route,
						code
					});
					const jsonStr = dates_score.replace(/'/g, '"');

					const dates_score_object = JSON.parse(jsonStr);
					const availableDatesFromData = Object.keys(dates_score_object).filter(date =>
						moment(date, "DD-MM-YYYY", true).isValid()
					);
					setSelectedDate(availableDatesFromData[0] || null);
					temDate = availableDatesFromData[0] || temDate;
					setAvailableDates(availableDatesFromData);

					if (channel && !allChannels.includes(channel)) allChannels.push(channel);
					if (aisight_channel && !allAisightChannels.includes(aisight_channel))
						allAisightChannels.push(aisight_channel);
					mk[sid] = {
						id: sid,
						census_id,
						label: name,
						name,
						position: { lat: coord[1], lng: coord[0] },
						isPoi: false,
						showInfo: true,
						isClient: true,
						data: {
							route,
							name,
							channel,
							aisight_channel,
							sales,
							morning_score,
							afternoon_score,
							evening_score,
							date_score: dates_score_object,
							growth_potential,
							score: Number(score) || 0,
							"Census ID": census_id
						}
					};
				}
			);

			setAllChannels(allChannels);
			setAllAisightChannels(allAisightChannels);

			const { newList, filteredShops } = assignScore(
				Object.values(mk),
				filter,
				timeOfDay,
				selectedChannel,
				selectedAisightChannel,
				temDate,
				markers.length
			);
			setShopList(newList);
			setShopCache(p => ({ ...p, [id]: newList }));
			setNumberOfShopsToShow(markers.length);

			setMapMarkers(filteredShops);
			setAllMarkers(mk);
			setMapCenter(Object.values(mk)[0]?.position || { lat: 0, lng: 0 });
		} catch (e) {
			console.error(e);
		}
		setLoadingShops(false);
	};

	return (
		<Fragment>
			<Navbar
				expand="md"
				className="py-0 flex-nowrap shadow"
				style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }}
			>
				<NavbarBrand>
					<img src={Logo} height="40" alt="SurveyAuto" />
				</NavbarBrand>
			</Navbar>
			<Container fluid className="main-content-height main-content-overflow px-0">
				<Spin spinning={loadingShops} tip="Loading shops...">
					<Row style={{ padding: 16, backgroundColor: "#f1f1f1" }}>
						<Col span={24}>
							<h2 className="px-3" style={{ fontWeight: 500, fontSize: 18 }}>
								Prioritize outlets based on highest footfall and busiest time of the day
							</h2>
						</Col>
						<Col span={24}>
							<div className="d-flex pl-3">
								<Radio.Group value={downloadScope} onChange={e => setDownloadScope(e.target.value)}>
									<Radio.Button value="City" style={{ marginRight: 8, borderRadius: "4px" }}>
										City
									</Radio.Button>
									<Radio.Button value="District" style={{ borderRadius: "4px" }}>
										District
									</Radio.Button>
								</Radio.Group>
							</div>
						</Col>
						{/* Download */}
						<Col span={24} style={{ padding: "0 16px", marginBottom: 8 }}>
							<Row className="my-2" gutter={[8, 8]} align="middle">
								<Col span={6} className="d-flex align-items-centerx flex-column">
									<h6 className="mb-0 pr-2" style={{ fontWeight: 500, fontSize: "12px" }}>
										CITY
									</h6>
									<Select
										value={selectedCity}
										onChange={setSelectedCity}
										disabled={downloadScope !== "City"}
										style={{ width: "100%" }}
									>
										{cities.map(c => (
											<Option key={c._id} value={c._id}>
												{c.name}
											</Option>
										))}
									</Select>
								</Col>
								<Col span={6} className="d-flex align-items-centerx flex-column">
									<h6 className="mb-0 pr-2" style={{ fontWeight: 500, fontSize: "12px" }}>
										DISTRICT
									</h6>
									<Select
										value={selectedDistrict}
										onChange={setSelectedDistrict}
										disabled={downloadScope !== "District"}
										placeholder="Select DISTRICT"
										style={{ width: "100%" }}
									>
										{districts.map(d => (
											<Option key={d._id} value={d._id}>
												{d.name}
											</Option>
										))}
									</Select>
								</Col>
								{/* Load Shops */}
								{/* <Col span={2}>
							<Row justify="end" gutter={[16, 16]}>
								<Col span={3}>
									<Button
										type="primary"
										icon={<DownloadOutlined />}
										onClick={handleDownload}
										style={{
											marginBottom: "1rem"
										}}
									>
										Load Shops
									</Button>
								</Col>
							</Row>
						</Col> */}
								<Col span={6} className="d-flex align-items-centerx flex-column">
									<h6 className="mb-0 pr-2" style={{ fontWeight: 500, fontSize: "12px" }}>
										Channel (Selected : {selectedChannel || "None"})
									</h6>
									<Select
										allowClear
										mode="multiple"
										placeholder="Select Channels"
										style={{ width: "100%" }}
										value={selectedChannel}
										onChange={value => {
											setSelectedChannel(value);

											const { newList, filteredShops } = assignScore(
												allMarkers,
												filter,
												timeOfDay,
												value,
												selectedAisightChannel,
												selectedDate,
												numberOfShopsToShow,
												geographicDiversity,
												allPolygons,
												shopsEachPolygon
											);

											const aisightChannels = new Set(
												Object.values(filteredShops)
													?.map(marker => marker.data.aisight_channel)
													.filter(Boolean)
											);

											const allAisightChannels = Array.from(aisightChannels);

											setAllAisightChannels(allAisightChannels);

											setShopList(newList);
											setMapMarkers(filteredShops);
										}}
									>
										{allChannels.map(channel => (
											<Option key={channel} value={channel}>
												{channel}
											</Option>
										))}
									</Select>
								</Col>

								<Col span={6} className="d-flex align-items-centerx flex-column">
									<h6 className="mb-0 pr-2" style={{ fontWeight: 500, fontSize: "12px" }}>
										Aisight Channel (Selected : {selectedAisightChannel || "None"})
									</h6>
									<Select
										mode="multiple"
										value={selectedAisightChannel}
										allowClear
										placeholder="Select Aisight Channels"
										style={{ width: "100%" }}
										onChange={value => {
											setSelectedAisightChannel(value);

											const { newList, filteredShops } = assignScore(
												allMarkers,
												filter,
												timeOfDay,
												selectedChannel,
												value,
												selectedDate,
												numberOfShopsToShow,
												geographicDiversity,
												allPolygons,
												shopsEachPolygon
											);
											setShopList(newList);
											setMapMarkers(filteredShops);
										}}
									>
										{allAisightChannels.map(channel => (
											<Option key={channel} value={channel}>
												{channel}
											</Option>
										))}
									</Select>
								</Col>
							</Row>
						</Col>
						<Col span={24} style={{ padding: "0 16px", marginBottom: 8 }}>
							{/* Select antd componnet for Channel and aisightChannel */}
							<Row gutter={[8, 8]} align="middle">
								<Col span={12} className="d-flex">
									<div className="d-flex justify-content-between align-items-center">
										<h6 className="mb-0 pr-2" style={{ fontWeight: 500, fontSize: "12px" }}>
											Shops to Show :
										</h6>
										<Input
											disabled={geographicDiversity}
											type="number"
											min={0}
											max={allMarkers.length}
											value={numberOfShopsToShow}
											onChange={e => {
												const value = Number(e.target.value);
												setNumberOfShopsToShow(value);
												const { newList, filteredShops } = assignScore(
													allMarkers,
													filter,
													timeOfDay,
													selectedChannel,
													selectedAisightChannel,
													selectedDate,
													value,
													geographicDiversity,
													allPolygons,
													shopsEachPolygon
												);
												setShopList(newList);
												setMapMarkers(filteredShops);
											}}
											style={{ width: "100px", marginRight: "1rem" }}
										/>
									</div>
									<div className="d-flex justify-content-between align-items-center">
										<Checkbox
											checked={geographicDiversity}
											disabled={filter === "Growth Potential"}
											onChange={e => {
												setGeographicDiversity(e.target.checked);
												const { newList, filteredShops } = assignScore(
													allMarkers,
													filter,
													timeOfDay,
													selectedChannel,
													selectedAisightChannel,
													selectedDate,
													numberOfShopsToShow,
													e.target.checked,
													allPolygons,
													shopsEachPolygon
												);
												setShopList(newList);
												setMapMarkers(filteredShops);
												// const equalNumber = Math.floor(
												// 	numberOfShopsToShow / allPolygons.length
												// );
												// // get all polygons and assign equal number of shops to each polygon
												// const newMarkers = {};
												// // just pick equal number of shops from each polygon no matter what
												// Object.values(allPolygons).forEach(({ data: { store_list } }) => {

												// 	const shopsInPolygon = Object.values(allMarkers).filter(
												// 		({ census_id }) => {
												// 			return store_list.includes(census_id);
												// 		}
												// 	);
												// 	const selectedShops = shopsInPolygon.slice(0, equalNumber);
												// 	selectedShops.forEach(shop => {
												// 		newMarkers[shop.id] = shop;
												// 	});
												// });
												// setMapMarkers(newMarkers);
												// const { newList } = assignScore(
												// 	newMarkers,
												// 	filter,
												// 	timeOfDay,
												// 	selectedChannel,
												// 	selectedAisightChannel,
												// 	selectedDate,
												// 	equalNumber * allPolygons.length
												// );
												// setShopList(newList);
												// setAllMarkers(newMarkers);
											}}
										>
											Geographic diversity
										</Checkbox>
									</div>
									{(geographicDiversity || filter === "Growth Potential") && (
										<div className="d-flex justify-content-between align-items-center">
											<h6
												className="mb-0 pr-2"
												style={{ fontWeight: 500, fontSize: "12px", marginLeft: 10 }}
											>
												Maximum outlets per geographic zone :
											</h6>
											{/*  show drop down with number 1,2,3,4 */}
											<Select
												value={shopsEachPolygon}
												onChange={value => {
													setShopsEachPolygons(value);
													const { newList, filteredShops } = assignScore(
														allMarkers,
														filter,
														timeOfDay,
														selectedChannel,
														selectedAisightChannel,
														selectedDate,
														numberOfShopsToShow,
														geographicDiversity,
														allPolygons,
														value
													);
													setShopList(newList);
													setMapMarkers(filteredShops);
												}}
												style={{ width: "100px", marginLeft: "1rem" }}
											>
												{[1, 2, 3, 4].map(num => (
													<Option key={num} value={num}>
														{num}
													</Option>
												))}
											</Select>
										</div>
									)}
								</Col>

								<Col
									span={4}
									className="d-flex align-items-centerx flex-column justify-content-end ml-auto"
								>
									<h6 className="mb-0 pr-2" style={{ fontWeight: 500, fontSize: "12px" }}>
										Date :{" "}
										{!isEmpty(selectedDate) &&
											format(new Date(moment(selectedDate, "DD-MM-YYYY")), "do MMM, yy, EEEE")}
									</h6>
									<DatePicker
										placeholder="Select Date"
										disabledDate={current => !availableDates.includes(current.format("DD-MM-YYYY"))}
										value={moment(selectedDate, "DD-MM-YYYY")}
										format="DD-MM-YYYY"
										style={{ width: "100%" }}
										onChange={date => {
											setSelectedDate(date.format("DD-MM-YYYY").toString());
											const { newList, filteredShops } = assignScore(
												allMarkers,
												filter,
												timeOfDay,
												selectedChannel,
												selectedAisightChannel,
												date.format("DD-MM-YYYY").toString(),
												numberOfShopsToShow,
												geographicDiversity,
												allPolygons,
												shopsEachPolygon
											);
											setShopList(newList);
											setMapMarkers(filteredShops);
										}}
									/>
								</Col>
							</Row>
						</Col>

						{/* Map & Sidebar */}
						<Col span={24} style={{ padding: "0 16px 16px" }}>
							<Row gutter={24}>
								<Col span={14}>
									<div className="shadow" style={{ border: "1px solid #ccc", position: "relative" }}>
										<GoogleMap
											handleMarkerClick={marker => {
												setMarkerCardVisible(true);
												setSelectedMarker(marker);
											}}
											mapHeight={mapHeight}
											tenant_markers={mapMarkers}
											center={mapCenter}
											markers={{
												census_Shops: false,
												tenant_Shops: true,
												all_tenant_markers: false,
												total: Object.keys(mapMarkers || {}).length
											}}
											polygons={polygonsForMap}
										/>
									</div>
								</Col>
								<Col span={10}>
									<div
										className="shadow"
										style={{
											border: "1px solid #ccc"
										}}
									>
										<div className="px-2 py-3 d-flex flex-column justify-content-between align-items-center ">
											<Radio.Group
												value={filter}
												onChange={e => {
													setFilter(e.target.value);

													// set list as well
													const { newList, filteredShops } = assignScore(
														allMarkers,
														e.target.value,
														timeOfDay,
														selectedChannel,
														selectedAisightChannel,
														selectedDate,
														numberOfShopsToShow,
														geographicDiversity,
														allPolygons,
														shopsEachPolygon
													);
													setMapMarkers(filteredShops);
													setShopList(newList);
												}}
												style={{ marginBottom: 16 }}
											>
												<Radio value="Footfall" style={{ marginRight: 8 }}>
													Footfall
												</Radio>
												<Radio value="Growth Potential" style={{ marginRight: 8 }}>
													Growth Potential
												</Radio>
											</Radio.Group>
											<div style={{ position: "absolute", top: 4, right: 16, zIndex: 1000 }}>
												{/* …other controls… */}
												<Button
													className="Download-excel-button px-2 d-flex align-items-center justify-content-center"
													type="primary"
													icon={<DownloadOutlined />}
													onClick={handleExport}
													style={{ marginBottom: 8 }}
												>
													Excel
												</Button>
											</div>
											<Radio.Group
												value={timeOfDay}
												onChange={e => {
													setTimeOfDay(e.target.value);

													const { newList, filteredShops } = assignScore(
														allMarkers,
														filter,
														e.target.value,
														selectedChannel,
														selectedAisightChannel,
														selectedDate,
														numberOfShopsToShow,
														geographicDiversity,
														allPolygons,
														shopsEachPolygon
													);

													setShopList(newList);
													setMapMarkers(filteredShops);
												}}
											>
												<Tooltip title="8:00 AM – 11:59 AM">
													<Radio.Button value="Morning" style={{ marginRight: 8 }}>
														<BulbOutlined /> Morning
													</Radio.Button>
												</Tooltip>
												<Tooltip title="12:00 PM – 4:59 PM">
													<Radio.Button value="Afternoon" style={{ marginRight: 8 }}>
														<CloudOutlined /> Afternoon
													</Radio.Button>
												</Tooltip>
												<Tooltip title="5:00 PM – 11:00 PM">
													<Radio.Button value="Evening">
														<StarOutlined /> Evening
													</Radio.Button>
												</Tooltip>
											</Radio.Group>
										</div>

										<div
											className="scroll-area-lg1 scrollableListingsX   sec-wise shadow"
											style={{
												border: "1px solid #f0f0f0",
												overflowY: "auto",
												height: mapHeight - 100 + "px"
											}}
										>
											<Table
												dataSource={shopList}
												columns={shopColumns}
												pagination={{ pageSize: 10, showSizeChanger: false }}
												size="small"
												rowKey="key"
											/>
										</div>
									</div>
								</Col>
							</Row>
						</Col>
					</Row>
					{markerCardVisible && (
						<HandleMarkerClick
							key={selectedMarker?.id}
							visible={markerCardVisible}
							selectedMarker={selectedMarker}
							setVisible={value => {
								setMarkerCardVisible(value);
								setSelectedMarker(null);
							}}
						/>
					)}
				</Spin>
			</Container>
		</Fragment>
	);
};

export default PromotorSchedule;
